export default "__VITE_ASSET__acc134cb__"